import SearchService from '../services/search.service';
import idb from './idb';
import * as _ from 'lodash';
import moment from 'moment';
import { prepareDataSet } from '../utils/functions';

const dataset = JSON.parse(localStorage.getItem('dataset'));
const initialState = {
  dataSet: {
    players: [],
    teams: [],
    games: []
  },
  results: [],
  dataSetChange: false,
  resultsChange: false,
  recentSearches: JSON.parse(localStorage.getItem('recentSearches')) ? JSON.parse(localStorage.getItem('recentSearches')) : []
}

export const search = {
  state: dataset ? dataset : initialState,
  actions: {
    async fetchGlobal({ commit,dispatch }, payload) {
      let dataSet;
      dispatch('changeLoader',{show:true});
      let oldDataSet = await dispatch('getDataSet');
      if(!oldDataSet){
        let response = await SearchService.getGlobalDataSet(payload.leagueYearOffset);
        dataSet = prepareDataSet({...response.data});

        SearchService.getGlobalPlayersDataSet(payload.leagueYearOffset).then(async playerResponse => {
          dataSet = prepareDataSet({...dataSet,players:playerResponse.data});
          await idb.clearCollection('datasets');
          await idb.addToCollection(dataSet, 'datasets');
          commit('fetchGlobalSuccess', dataSet)
        })
      }else {
        dataSet = oldDataSet;
      }

      let gamesResponse = await SearchService.getGlobalGamesDataSet(payload.leagueYearOffset);
      dataSet = prepareDataSet({...dataSet,games:gamesResponse.data});

      await idb.clearCollection('datasets');
      await idb.addToCollection(Object.freeze(dataSet), 'datasets');
      commit('fetchGlobalSuccess', dataSet)
      dispatch('changeLoader',{show:false})


      return Object.freeze(dataSet);
    },
    async clearGlobal({ commit,dispatch }, payload) {
      await idb.clearCollection('datasets');
      await idb.clearCollection('results');
    },
    async getDataSet({ commit,state }, payload) {
      let dataSets = await idb.getCollection('datasets');
      return Object.freeze(_.first(dataSets));
    },
    async globalResultsChange({ commit }, payload) {
      let results = payload
      await idb.clearCollection('results');
      await idb.addToCollection(results, 'results');
      commit('globalResultsChangeSuccess', results)
      return Object.freeze(results);
    },
    async getGlobalResults({ commit }, payload) {
      let resultsSets = await idb.getCollection('results');
      return Object.freeze(_.first(resultsSets));
    },
    async addRecentSearch({ commit }, payload) {
      let search = {
        createdAt: moment().format('DD/MM/YYYY HH:mm'),
        metaInfo:{
          filters: payload.filters,
          headers: payload.headers,
          tab: payload.tab
        }
      }
      commit('newRecentSearchSuccess', search)
    },
    async clearRecentSearches({ commit }, payload) {
      commit('clearRecentSearchesSuccess')
    }
  },
  getters: {
    dataSet: state => state.dataSet,
    results: state => state.results,
    recentSearches: state => state.recentSearches
  },
  mutations: {
    fetchGlobalSuccess(state, dataset) {
      state.dataSetChange = !state.dataSetChange;
    },
    fetchGlobalError(state) {
      state.dataSet = initialState.dataSet;
    },
    globalResultsChangeSuccess(state, results) {
      state.resultsChange = !state.resultsChange;
    },
    newRecentSearchSuccess(state, search) {
      state.recentSearches.unshift(search);
      state.recentSearches = _.slice(state.recentSearches, 0, 30);
      localStorage.setItem('recentSearches', JSON.stringify(state.recentSearches))
    },
    clearRecentSearchesSuccess(state, search) {
      state.recentSearches = [];
      localStorage.setItem('recentSearches', JSON.stringify(state.recentSearches));
    }
  },
};

export default search;
